import { useSuspenseQuery } from '@tanstack/react-query'
import { strapiClient } from '~/shared/api/strapi'

export function useReleaseNotes() {
  return useSuspenseQuery({
    ...strapiClient.getReleaseNotesOptions(),
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  })
}
